import { render } from "./DriverTable.vue?vue&type=template&id=f1d89a5e"
import script from "./DriverTable.vue?vue&type=script&lang=js"
export * from "./DriverTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__